import {strCode} from '../consts/strCode';
import notificationService from '../services/notificationService';

export const copyToBuffer = (text) => {
    navigator.clipboard.writeText(text);

    notificationService.showToastNotification({messageStr: strCode.GLOBAL_COPY_SUCCESS_MESSAGE});
};
